import { Block } from '@/components/base/Block'
import { Heading4 } from '@/components/base/Heading'
import { Text3 } from '@/components/base/Text'
import { useApp } from '@/hooks/useApp'
import { align } from '@/styles/display'
import spaceStyle from '@/styles/space'
import { whiteSpace } from '@/styles/white_space'
import { V1JobOfferAcceptanceStatusType } from 'mnvm-mypage-app-ts-if'
import { type Dispatch, type SetStateAction } from 'react'

interface Props {
  isShowFullText: boolean
  setIsShowFullText: Dispatch<SetStateAction<boolean>>
  caMessage: string
  status: V1JobOfferAcceptanceStatusType
}

export const OfferAcceptanceMessageSection = ({
  isShowFullText,
  setIsShowFullText,
  caMessage,
  status
}: Props): JSX.Element => {
  const app = useApp()

  return status === V1JobOfferAcceptanceStatusType.Pending ? (
    <>
      <Heading4 fixedSPfontSize margin={{ vertical: spaceStyle.NONE }}>
        担当キャリアアドバイザーからのメッセージ
      </Heading4>
      <Text3
        textColor={app.theme.mainTextColor}
        margin={{ horizontal: spaceStyle.NONE }}
        whiteSpace={whiteSpace.PRE_LINE}
        maxLines={isShowFullText ? undefined : 4}
      >
        {caMessage}
      </Text3>
      <Block width={'100%'} textAlign={align.CENTER}>
        <Text3
          textColor={app.theme.primaryMainColor}
          margin={{ all: spaceStyle.NONE }}
          underline
          onClick={() => {
            setIsShowFullText(!isShowFullText)
          }}
        >
          {isShowFullText ? '閉じる' : '全文を表示する'}
        </Text3>
      </Block>
    </>
  ) : (
    <></>
  )
}
